// @ts-nocheck
import styled from 'styled-components';

export const ReportingAssistantChatStyled = styled.div`
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 10;
`;
